<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import ScenariosCard from 'dashboard/components-next/captain/assistant/ScenariosCard.vue';

defineProps({
  scenarios: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['approve', 'discard', 'update']);

const { t } = useI18n();

// A proposal cites the conversations it was drawn from, so whoever reviews it can go and
// read them before deciding.
const sourceCount = scenario =>
  (scenario.generation_metadata?.conversation_ids ?? []).length;
</script>

<template>
  <div class="flex flex-col gap-4 mt-7">
    <div class="flex flex-col gap-1">
      <span class="text-sm font-medium text-n-slate-12">
        {{
          t('CAPTAIN.ASSISTANTS.SCENARIOS.PENDING.TITLE', {
            count: scenarios.length,
          })
        }}
      </span>
      <span class="text-sm text-n-slate-11">
        {{ t('CAPTAIN.ASSISTANTS.SCENARIOS.PENDING.DESCRIPTION') }}
      </span>
    </div>

    <div
      v-for="scenario in scenarios"
      :key="scenario.id"
      class="flex flex-col gap-2 p-3 border rounded-xl border-n-amber-6 bg-n-amber-2"
    >
      <div class="flex items-center justify-between gap-3">
        <span class="text-sm text-n-slate-11">
          {{
            t('CAPTAIN.ASSISTANTS.SCENARIOS.PENDING.SOURCES', {
              count: sourceCount(scenario),
            })
          }}
        </span>
        <div class="flex gap-2 flex-shrink-0">
          <Button
            :label="t('CAPTAIN.ASSISTANTS.SCENARIOS.PENDING.DISCARD')"
            ghost
            slate
            sm
            @click="emit('discard', scenario.id)"
          />
          <Button
            :label="t('CAPTAIN.ASSISTANTS.SCENARIOS.PENDING.APPROVE')"
            sm
            @click="emit('approve', scenario.id)"
          />
        </div>
      </div>

      <ScenariosCard
        :id="scenario.id"
        :title="scenario.title"
        :description="scenario.description"
        :instruction="scenario.instruction"
        :tools="scenario.tools"
        @update="emit('update', $event)"
        @delete="emit('discard', scenario.id)"
      />
    </div>
  </div>
</template>
